import * as React from 'react'
import {Field} from "@intelingu/core/components/form/Field";
import {Checkbox} from "./form/elements/Checkbox";
import {FormGroup} from "./form/elements/FormGroup";
import {useState} from "react";

const answers = [
    { title: 'was correct / stylistic comment only', value: 1 },
    { title: 'fixed within few seconds', value: 2 },
    { title: 'structural fixes', value: 3 },
    { title: 'whole enhancer affected / obvious professional defects', value: 4 },
]

export const EscalationEvaluation = props => {
    const [selected, setSelected] = useState(null)

    return <div>

       <h4 className={'mb-3 mt-3'}>Evaluation</h4>
        { answers.map(item => (
            <div key={item.value}>
                <label style={{fontWeight: 400}}>
                    <input type={'radio'} name={'evaluation'} onChange={v => {
                        setSelected(item.value)
                        props.onChange(item.value)
                    }} />&nbsp;&nbsp;
                    { item.title }
                </label>
            </div>
        )) }
    </div>
}
